import React from 'react'
import SortingVisalizer from './SortingVisalizer'
const App = () => {
    return (
        <div>
            <SortingVisalizer/>
        </div>
    )
}

export default App

